import GS from '../../grafsync/grafsync';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../../core/withGShoc';
import ShaclPropertyPath from './ShaclPropertyPath';

class ShaclProperty extends React.Component {

    state = {
        patternTest: ""
    };

    updatePatternTest = (patternTest) => this.setState({ patternTest });

    onDeletePattern = (value) => {
        this.props.onDelete("shPattern", value);
        this.setState({ patternTest: '' });
    };

    onDeleteValue = (prop) => (value) => this.props.onDelete(prop, value);

    addNewLiteral = (property) => (language, text) => {
        GS.addProperty(this.props.id, this.props.graph, property, text, language, null);
    };

    onUpdate = (property, lang, index) => (value) => this.props.onUpdate(property, value, lang, index);

    onDelete = (property, lang) => (value) => this.props.onDelete(property, value, lang);

    handleMediaMappingChange = (treatContentAs) => {
        if (treatContentAs === "none") {
            if (this.props.data["treatContentAs"]) this.props.onDelete('treatContentAs', this.props.data["treatContentAs"]);
        }
        else {
            this.props.data["treatContentAs"] && this.props.data["treatContentAs"] !== undefined ?
                this.props.onUpdate('treatContentAs', treatContentAs)
                :
                this.props.onAdd('treatContentAs', treatContentAs);
        }
    };

    onSetPattern = (value) => {
        const exists = this.props.data["shPattern"];
        if (!exists) {
            this.props.onAdd("shPattern", value);
        }
        else this.props.onUpdate("shPattern", value);
    };

    onSetMinCount = (value) => {
        const minCount = parseInt(value);
        const exists = this.props.data["shMinCount"];
        if (!exists) {
            this.props.onAdd("shMinCount", minCount);
        }
        else this.props.onUpdate("shMinCount", minCount);
    };

    onSetMaxCount = (value) => {
        const maxCount = parseInt(value);
        const exists = this.props.data["shMaxCount"];
        if (!exists) {
            this.props.onAdd("shMaxCount", maxCount);
        }
        else this.props.onUpdate("shMaxCount", maxCount);
    };

    onSetMaxLength = (value) => {
        const maxLength = parseInt(value);
        const exists = this.props.data["shMaxLength"];
        if (!exists) {
            this.props.onAdd("shMaxLength", maxLength);
        }
        else this.props.onUpdate("shMaxLength", maxLength);
    };

    onAddComponent = (iri, project) => {
        // Will only ever be one value due to SHACL setup
        if (!this.props.data.inComponent || !this.props.data.inComponent.includes(iri)) {
            this.props.onAdd("inComponent", iri);
            if (project && !this.props.data.inComponentProject) {
                this.props.onAdd("inComponentProject", project);
            }
            else {
                if (this.props.data.inComponentProject !== project) {
                    this.props.onUpdate("inComponentProject", project);
                }
            }
        }
    };

    render() {

        const { data, defaultLang, dataTest, id, isReadOnly, graph, ontologyProjectGraph, modules,
            onDeleteLink, project, enableProjectSelection, includeSelectFrom } = this.props;
        const { patternTest } = this.state;
        const shPath = data.shPath;
        if (!shPath) return null;

        return (
            <ShaclPropertyPath
                dataTest={dataTest}
                key={shPath}
                id={shPath}
                propertyShapeData={data}
                onDeleteLink={onDeleteLink}
                project={project}
                suppressLoading={true}
                modules={modules}
                includeSelectFrom={includeSelectFrom}
                enableProjectSelection={enableProjectSelection}
                patternTest={patternTest}
                onSetMinCount={this.onSetMinCount}
                onSetMaxCount={this.onSetMaxCount}
                onSetMaxLength={this.onSetMaxLength}
                onAddComponent={this.onAddComponent}
                onDeletePattern={this.onDeletePattern}
                onSetPattern={this.onSetPattern}
                updatePatternTest={this.updatePatternTest}
                handleMediaMappingChange={this.handleMediaMappingChange}
                onDeleteValue={this.onDeleteValue}
                onUpdate={this.onUpdate}
                onDelete={this.onDelete}
                onAddLanguage={this.addNewLiteral}
                handleNotAvailable={true}
                isReadOnly={isReadOnly}
                projectGraph={graph}
                graph={ontologyProjectGraph}
                source={id}
                viewLang={defaultLang}
                defaultLang={defaultLang} />
        );
    }
}

ShaclProperty.defaultProps = {
    isReadOnly: false,
    enableProjectSelection: false,
    modules: 0
};

ShaclProperty.propTypes = {
    dataTest: PropTypes.string,
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    project: PropTypes.string.isRequired,
    modules: PropTypes.number,
    graph: PropTypes.string.isRequired,
    onDeleteLink: PropTypes.func.isRequired,
    enableProjectSelection: PropTypes.bool,
    includeSelectFrom: PropTypes.bool,
    ontologyProjectGraph: PropTypes.string.isRequired,
    isReadOnly: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired
};

export default withGS(ShaclProperty);